import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

export type IntegrationPageNameContextType = {
  integrationPageName: string;
  setIntegrationPageName: Dispatch<SetStateAction<string>>;
};

export const IntegrationPageNameContext =
  createContext<IntegrationPageNameContextType>(
    {} as IntegrationPageNameContextType
  );

export const IntegrationPageNameContextProvider = ({
  children,
}: React.PropsWithChildren) => {
  const [integrationPageName, setIntegrationPageName] = useState("");
  return (
    <IntegrationPageNameContext.Provider
      value={{ integrationPageName, setIntegrationPageName }}
    >
      {children}
    </IntegrationPageNameContext.Provider>
  );
};

export const useIntegrationPageName = () =>
  useContext(IntegrationPageNameContext);
